import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Granularity } from '../../../core/models/domain.models';

/** Month / year granularity toggle. */
@Component({
  selector: 'app-granularity-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './granularity-toggle.component.html',
  styleUrl: './granularity-toggle.component.scss',
})
export class GranularityToggleComponent {
  value = input.required<Granularity>();
  change = output<Granularity>();
}
